var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPapierkorb = function SvgIconPapierkorb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "307-a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a50cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c369e"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M8.139 53.231a6.3 6.3 0 0 0 6.279 6.279h25.116a6.3 6.3 0 0 0 6.279-6.279V15.558H8.139ZM48.952 6.139H37.964L34.825 3h-15.7l-3.137 3.139H5v6.279h43.952Z",
    transform: "translate(13 9)",
    style: {
      fill: "url(#307-a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h80v80H0z"
  }));
};
export default SvgIconPapierkorb;